/* ROSÉE — page produit : avis complets (filtres, répartition, « Voir plus », formulaire d'avis, photos, notes sans commentaire) */
(function () {
  'use strict';

  function ouvrir(dlg) {
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') {
      if (!dlg.open) dlg.showModal();
    } else {
      dlg.setAttribute('open', '');
    }
  }
  function fermer(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close();
    else dlg.removeAttribute('open');
  }
  function brancherDialog(dlg) {
    if (!dlg) return;
    dlg.querySelectorAll('[data-rp-fermer]').forEach(function (b) {
      b.addEventListener('click', function () { fermer(dlg); });
    });
    // Clic sur le fond : ferme
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg) fermer(dlg); });
  }

  // Notes sans commentaire (custom.avis_notes) : cartes ajoutées après les avis commentés.
  function ajouterNotes(racine) {
    var src = racine.querySelector('[data-rp-notes]');
    var grille = racine.querySelector('.rp-grille');
    if (!src || !grille) return;
    var notes;
    try { notes = JSON.parse(src.textContent); } catch (e) { return; }
    var lang = document.documentElement.lang || 'fr';
    var txt = racine.dataset.txtNote || '';
    var sur5 = racine.dataset.txtSur5 || '%n/5';
    var frag = document.createDocumentFragment();
    notes.forEach(function (x) {
      var n = Math.max(1, Math.min(5, +x[0] || 5));
      var c = document.createElement('article');
      c.className = 'rp-carte rp-carte-note';
      c.dataset.n = String(n); c.dataset.tag = ''; c.dataset.photo = '0';
      c.hidden = true;
      var haut = document.createElement('div'); haut.className = 'rp-carte-haut';
      var et = document.createElement('span'); et.className = 'rs-etoiles'; et.style.setProperty('--n', n);
      et.setAttribute('role', 'img'); et.setAttribute('aria-label', sur5.replace('%n', n));
      haut.appendChild(et);
      if (x[1]) {
        var d = new Date(x[1] + 'T12:00:00');
        var s = document.createElement('span');
        s.textContent = isNaN(d) ? x[1] : d.toLocaleDateString(lang, { day: 'numeric', month: 'short', year: 'numeric' });
        haut.appendChild(s);
      }
      var p = document.createElement('p'); p.className = 'rp-note-seule'; p.textContent = txt;
      c.appendChild(haut); c.appendChild(p);
      frag.appendChild(c);
    });
    grille.appendChild(frag);
  }

  function init(racine) {
    if (racine.dataset.rpPret) return;
    racine.dataset.rpPret = '1';

    var parPage = parseInt(racine.dataset.parPage, 10) || 6;
    var limite = parPage;
    ajouterNotes(racine);
    var cartes = Array.prototype.slice.call(racine.querySelectorAll('.rp-carte'));
    var fbs = racine.querySelectorAll('[data-rp-filtres] button');
    var rbs = racine.querySelectorAll('.rp-repartition button');
    var plus = racine.querySelector('[data-rp-plus]');
    var zonePlus = plus ? plus.parentElement : null;
    var aucun = racine.querySelector('[data-rp-aucun]');
    var test = function () { return true; };

    function afficher() {
      var vus = 0;
      cartes.forEach(function (c) {
        var ok = test(c);
        if (ok) vus++;
        c.hidden = !ok || vus > limite;
      });
      if (zonePlus) zonePlus.hidden = vus <= limite;
      if (aucun) aucun.hidden = vus > 0;
    }

    // Filtres : Tous / Avec photo / par tag
    fbs.forEach(function (b) {
      b.addEventListener('click', function () {
        fbs.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        rbs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        var v = b.getAttribute('data-f') || '';
        test = function (c) { return !v || (v === 'photo' ? c.dataset.photo === '1' : c.dataset.tag === v); };
        limite = parPage;
        afficher();
      });
    });

    // Répartition : filtre par nombre d'étoiles (second clic = retour à « Tous »)
    rbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        rbs.forEach(function (x) { x.setAttribute('aria-pressed', String(on && x === b)); });
        fbs.forEach(function (x, i) { x.setAttribute('aria-pressed', String(!on && i === 0)); });
        var k = b.dataset.etoiles;
        test = function (c) { return !on || c.dataset.n === k; };
        limite = parPage;
        afficher();
      });
    });

    // « Voir plus d'avis » : +parPage
    if (plus) {
      plus.addEventListener('click', function () {
        limite += parPage;
        afficher();
      });
    }

    // Formulaire d'avis
    var dlgAvis = racine.querySelector('[data-rp-dlg-avis]');
    brancherDialog(dlgAvis);
    racine.querySelectorAll('[data-rp-ouvrir-avis]').forEach(function (b) {
      b.addEventListener('click', function () { ouvrir(dlgAvis); });
    });
    if (dlgAvis) {
      // Étoiles de la note
      var notes = dlgAvis.querySelectorAll('.rp-notes label');
      notes.forEach(function (l) {
        var r = l.querySelector('input');
        if (!r) return;
        r.addEventListener('change', function () {
          var n = +l.dataset.n;
          notes.forEach(function (x) { x.classList.toggle('on', +x.dataset.n <= n); });
        });
      });
      // Piège à robots : envoi bloqué si le champ caché est rempli
      var form = dlgAvis.querySelector('form');
      var piege = dlgAvis.querySelector('[data-rp-piege]');
      if (form && piege) {
        form.addEventListener('submit', function (ev) {
          if (piege.value) { ev.preventDefault(); fermer(dlgAvis); }
        });
      }
      // Après envoi (remerciement) ou en cas d'erreur : rouvrir la fenêtre
      if (dlgAvis.querySelector('[data-rp-ouvrir-auto]')) ouvrir(dlgAvis);
    }

    // Photo d'un avis en grand
    var dlgPhoto = racine.querySelector('[data-rp-dlg-photo]');
    var grande = dlgPhoto ? dlgPhoto.querySelector('[data-rp-photo-grande]') : null;
    brancherDialog(dlgPhoto);
    racine.querySelectorAll('[data-rp-photo]').forEach(function (b) {
      b.addEventListener('click', function () {
        var img = b.querySelector('img');
        if (!img || !grande) return;
        grande.src = img.currentSrc || img.src;
        ouvrir(dlgPhoto);
      });
    });

    afficher();
  }

  function tout() {
    document.querySelectorAll('[data-rp-avis]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  // Éditeur de thème : section rechargée
  document.addEventListener('shopify:section:load', tout);
})();
